import { useMutation, useQueryClient } from '@tanstack/react-query';
import { toast } from 'sonner';
import { updateSettingsAPI } from 'src/api';
import { ToastStyled } from 'src/components';
import type { OrganizationSettings } from 'src/types';

export const useUpdateSettings = () => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: (settings: OrganizationSettings) => updateSettingsAPI(settings),
    onSuccess: () => {
      toast.custom((toastBlock) => (
        <ToastStyled
          variant='success'
          handleClose={() => toast.dismiss(toastBlock)}
        >
          Settings updated successfully!
        </ToastStyled>
      ));

      // invalidate the current user query to get the updated settings
      queryClient.invalidateQueries({
        queryKey: ['currentUser'],
      });
    },
    onError: () => {
      toast.custom((toastBlock) => (
        <ToastStyled
          variant='error'
          handleClose={() => toast.dismiss(toastBlock)}
        >
          Failed to update settings.
        </ToastStyled>
      ));
    },
  });
};
